import './productClearances.scss';

import React, { useEffect, useState } from 'react';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

type ProductClearancesProps = {
    product: Queries.ProductJsonTemplateFragment;
};

export default function ProductClearances(props: ProductClearancesProps) {
    const { product } = props;
    const { currentLocale } = usePageLocalization();
    const [clearanceArray, setClearanceArray] = useState<any[][]>([]);

    const attributes = product.attributes ? product.attributes : {};
    const { t } = useTranslation('templatePages');

    const category_name = product?.category?.split('/')[3];

    useEffect(() => {
        const filteredClearanceArray: any[] = Object.entries(attributes).filter(
            (attribute: any) => {
                return attribute[1] && attribute[1].group === 'Degagements';
            }
        );

        const codeList =
            category_name === 'Wood Stoves'
                ? [
                      'DesSCA',
                      'DesDCA',
                      'DesSUS',
                      'DesDUS',
                      'ArrSCA',
                      'ArrDCA',
                      'ArrSUS',
                      'ArrDUS',
                      'CoiSCA',
                      'CoiDCA',
                      'CoiSUS',
                      'CoiDUS',
                      'CotSCA',
                      'CotDCA',
                      'CotSUS',
                      'CotDUS',
                  ]
                : [
                      'DesSCA',
                      'DesSUS',
                      'ManCoCA',
                      'ManCoUS',
                      'ManSuCA',
                      'ManSuUS',
                      'MurCoCA',
                      'MurCoUs',
                      'PlanCAi',
                      'PlanUSi',
                      'TabC',
                      'TabU',
                  ];

        let newClearanceArray: any[] = [];

        for (const code of codeList) {
            const item = filteredClearanceArray.find((item) => item[0] === code && item[1]);
            if (item) {
                newClearanceArray.push(item);
            }
        }

        setClearanceArray(newClearanceArray);
    }, [product, attributes]);

    const stoveTableRow = (index: number): JSX.Element => {
        return (
            <tr key={index}>
                <th className='clearance-title'>
                    {`${t('clearance')} - ${
                        clearanceArray[index][1].name[currentLocale]
                    }${index === 12 ? ' **' : ''}`}
                </th>
                {currentLocale !== 'en_US' ? (
                    <>
                        <td>
                            {clearanceArray[index][1].values[0][currentLocale]}
                        </td>
                        <td>
                            {
                                clearanceArray[index + 1][1].values[0][
                                    currentLocale
                                ]
                            }
                        </td>
                    </>
                ) : (
                    <>
                        <td>
                            {
                                clearanceArray[index + 2][1].values[0][
                                    currentLocale
                                ]
                            }
                        </td>
                        <td>
                            {
                                clearanceArray[index + 3][1].values[0][
                                    currentLocale
                                ]
                            }
                        </td>
                    </>
                )}
            </tr>
        );
    };

    const insertTableRow = (index: number): JSX.Element => {
        return (
            <tr key={index}>
                <th className='clearance-title'>
                    {`${t('clearance')} - ${
                        clearanceArray[index][1].name[currentLocale]
                    }${index === 0 ? ' **' : ''}`}
                </th>
                <td colSpan={2}>
                    {clearanceArray[index][1].values[0][currentLocale]}
                </td>
            </tr>
        );
    };

    return (
        <div className='product-clearances'>
            <h4 className='mobile-view'>{t('clearance')}</h4>
            <table>
                <tbody>
                    <tr>
                        <th>
                            <h4 className='desktop-view'>{t('clearance')}</h4>
                        </th>
                        {currentLocale === 'en_US' ? (
                            <td colSpan={2} className='country'>
                                {t('usa')}
                            </td>
                        ) : (
                            <td colSpan={2} className='country'>
                                {t('canada')}
                            </td>
                        )}
                    </tr>

                    {category_name === 'Wood Stoves' && (
                        <tr>
                            <th></th>
                            <td className='pipe'>{t('simple-pipe')}</td>
                            <td className='pipe'>{t('double-pipe')}</td>
                        </tr>
                    )}

                    {category_name === 'Wood Stoves'
                        ? clearanceArray.map((attribute, index) => {
                              return index % 4 === 0 && stoveTableRow(index);
                          })
                        : clearanceArray.map((attribute, index) => {
                              return index % 2 === 0 && insertTableRow(index);
                          })}

                    <tr>
                        <td className='empty'></td>
                    </tr>
                    <tr className='footnote'>
                        <td colSpan={5}>
                            <p>{t('clearance-footnote')}</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
